import { useCallback, useState } from "react";
import { logService } from "../services";
import type { LogEntry } from "../services/logService";

function LogsPage() {
  const [logs, setLogs] = useState<LogEntry[]>(() => logService.getLogs());

  const refresh = useCallback(() => {
    setLogs(logService.getLogs());
  }, []);

  const clear = useCallback(() => {
    logService.clearLogs();
    setLogs([]);
  }, []);

  // Newest first is easier to scan on a phone.
  const ordered = [...logs].reverse();

  return (
    <div className="p-3 w-100" style={{ textAlign: "left" }}>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h1 className="h4 mb-0">Error logs</h1>
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={refresh}
          >
            Refresh
          </button>
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            onClick={clear}
            disabled={logs.length === 0}
          >
            Clear
          </button>
        </div>
      </div>

      <p className="text-muted small">
        Showing the last {logs.length} captured error
        {logs.length === 1 ? "" : "s"} (max 50), newest first.
      </p>

      {ordered.length === 0 ? (
        <p className="text-muted">No errors logged.</p>
      ) : (
        <ul className="list-unstyled">
          {ordered.map((entry, idx) => (
            <li
              key={`${entry.timestamp}-${idx}`}
              className="border rounded p-2 mb-2"
            >
              <div className="small text-muted">{entry.timestamp}</div>
              <div className="fw-semibold text-danger">{entry.message}</div>
              {entry.detail ? (
                <pre
                  className="bg-dark text-light p-2 rounded mt-2 mb-0"
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    maxHeight: "30vh",
                    overflow: "auto",
                  }}
                >
                  {entry.detail}
                </pre>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default LogsPage;
